import { edmCampaign } from '@bingads-webui/edm-campaign';

const adGroupEDM = edmCampaign.types.resolve('Model.AdGroup');
const adGroupResource = new adGroupEDM.ResourceIdentifier();

export const createOrUpdateAdGroup = (data) => {
  const createOrUpdateCall = data && data.Id ?
    adGroupResource.bulkUpdate.bind(adGroupResource) :
    adGroupResource.bulkCreate.bind(adGroupResource);
  return createOrUpdateCall(data);
};

export const readAdGroup = (cid, aid, campaignId, adGroupId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .get()
    .toPromise();
